import { IQuoteProductDocumentServiceMock } from './document.mock.types';

export const mockQuoteProductService = (): IQuoteProductDocumentServiceMock => ({
  fetchQuoteProductDocuments: jest.fn(),
  fetchQuoteProductDocument: jest.fn(),
  createQuoteProductDocument: jest.fn(),
  updateQuoteProductDocument: jest.fn(),
  deleteQuoteProductDocument: jest.fn(),

  fetchDocumentRevisions: jest.fn(),
  //Tag
  fetchQuoteDocumentTags: jest.fn(),
  createQuoteDocumentTag: jest.fn(),
  updateQuoteDocumentTag: jest.fn(),
  deleteQuoteDocumentTag: jest.fn(),

  setQuoteProductDocumentTags: jest.fn()
});
